/* eslint-disable */

/* global Sys:true */
(function() {
  "use strict";

  if ($(".hidden-billing").hasClass("open-billing")) {
    $(".hidden-billing").show();
  } else {
    $(".hidden-billing").hide();
  }

  // reload billing address buttons on partial postback
  var prm = Sys.WebForms.PageRequestManager.getInstance();
  if (prm !== null) {
    /* jshint camelcase:false */
    prm.add_endRequest(function(sender, e) {
      /* jshint camelcase:true */
      if (sender._postBackSettings.panelsToUpdate !== null) {
        if ($(".hidden-billing").hasClass("open-billing")) {
          $(".hidden-billing").show();
        } else {
          $(".hidden-billing").hide();
        }

        if ($(".checkout-error-small") !== null) {
          $(".checkout-error-postcode").html($(".checkout-error-small").html());
        }
      }
    });
  }

  function cartHeight() {
    $(".cart-item")
      .children(".col1, .col2, .col3, .col4, .col5")
      .css("height", "auto");
    $(".cart-item")
      .children(".col1, .col2")
      .children()
      .children("h4")
      .css("height", "auto");
    $(".cart-item").each(function() {
      var varHeight = $(this).height();
      $(this)
        .children(".col1, .col2, .col3, .col4, .col5")
        .css("height", varHeight);

      var col1h4 = $(this)
        .children(".col1")
        .children()
        .children("h4")
        .height();
      var col2h4 = $(this)
        .children(".col2")
        .children()
        .children("h4")
        .height();

      if (col1h4 > col2h4) {
        $(this)
          .children(".col2")
          .children()
          .children("h4")
          .css("height", col1h4);
      } else {
        $(this)
          .children(".col1")
          .children()
          .children("h4")
          .css("height", col2h4);
      }
    });
  }

  function cartTotalHeight() {
    $(".cart-totals")
      .children(".col1, .col2")
      .css("height", "auto");
    $(".cart-totals").each(function() {
      var varHeight = $(this).height();
      $(this)
        .children(".col1, .col2")
        .css("height", varHeight);
    });
  }
  cartHeight();
  cartTotalHeight();
  $(window).resize(function() {
    cartHeight();
    cartTotalHeight();
  });

  var qtyCount = 0;
  $(".quantity-box input[type=text]").each(function() {
    var thisVal = $(this).attr("value");
    if (!isNaN(thisVal)) {
      qtyCount += parseInt(thisVal);
    }
  });

  if (window.location.href.indexOf("/shop/cart") > -1) {
    $("#header-cart-count").html(qtyCount);
  }
})();
